import React from 'react'
import { Box, Typography } from '@mui/material'
import { getValueFromObjectByKeys, translate } from '../../helper'
import { OdFontScale, ReplyButton } from './components'
import { connect } from 'react-redux'
import { setOrderDetailsSliceData } from '../../mobile/modules/Orders/Slice/ordersDetailSlice'
import APIManager from '../../connection/ApiManager'
import { signInWithCustomToken } from 'firebase/auth'
import { auth } from '../../firebase'
import firebase from 'firebase/compat/app'
import { ENV } from '../../Env'
import { formatMessageBody } from '../../utils/formatMessageBody';
import { fetchFileUrlMap, fetchFileUrlByPath, getThumbPathsFromMessages } from '../../utils/fileUrls'
import CustomSpinner from '../../common/CustomSpinner';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import  ThumbDefault  from '../../assets/image/svg/Thumb_default.svg';
import { formatDate, resolveCssVarValue } from '../../utils/CommonFunction'
import MessageImageZoom from '../../common/message-image-zoom';

const MessagesList = (props) => {
    const {
        orderDetail,
        vendorId,
        messages,
        setMessages,
        messagesLoading,
        setMessagesLoading,
        chatBoxHeight,
        showTextButtons
    } = props

    const { userInfo: { profile: { user, vendor } = {} } = {} } = props
    const isWhiteLabelPartner = user?.role === "White Label Partner Admin";
    const [loadingImages, setLoadingImages] = React.useState({});
    const fileUrlMapRef = React.useRef({});
    const thumbUrlMapRef = React.useRef({});
    const chatBoxRef = React.useRef(null);

    const [showModal, setShowModal] = React.useState(false);
    const [clickedImage, setClickedImage] = React.useState(null);
    const [imageList, setImageList] = React.useState([]);
    const [imageStartIndex, setImageStartIndex] = React.useState(0);

    const handleImageLoad = (url) => {
        setLoadingImages((prev) => ({ ...prev, [url]: false }));
    };

    const handleImageStart = (url) => {
        setLoadingImages((prev) => ({ ...prev, [url]: true }));
    };

    React.useEffect(() => {
        getChats()

        return () => {
            props.clearOrderInViewDetails()
        }
    }, [])

    React.useEffect(() => {
        if (chatBoxRef.current) {
            setTimeout(() => {
                chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
            }, 0);
        }
    }, [messages]);

    const getChats = async () => {
        try {
            const res1 = await APIManager.getInstance().getFirebaseAuthToken();
            const resAuth = await signInWithCustomToken(auth, res1?.data?.token);
            let docID = `order_${orderDetail.id}_vendor_${vendorId}`;

            firebase
                .firestore()
                .collection(ENV.APP_CHATS || 'order_vendor_chats')
                .doc(docID)
                .collection('messages')
                .onSnapshot(async (documentSnapshot) => {
                    let newMessages = [];
                    documentSnapshot.forEach((doc) => newMessages.push(doc.data()));
                    const isInitialThumbLoad = Object.keys(thumbUrlMapRef.current).length === 0;
                    let thumbsToFetch = [];
                    if (isInitialThumbLoad) {
                        thumbsToFetch = getThumbPathsFromMessages(newMessages);
                    } else {
                        const knownThumbs = new Set(Object.keys(thumbUrlMapRef.current));
                        thumbsToFetch = getThumbPathsFromMessages(newMessages, knownThumbs);
                    }

                    if (thumbsToFetch.length > 0) {
                        try {
                            const map = await fetchFileUrlMap(thumbsToFetch);
                            Object.keys(map).forEach((filename) => {
                                thumbUrlMapRef.current[filename] = map[filename];
                            });
                        } catch (error) {
                            console.error('Error fetching thumbnail URLs:', error);
                        }
                    }

                    const updatedMessages = newMessages.map(message => {
                        if (Array.isArray(message.data?.attachments)) {
                            const updatedAttachments = message.data.attachments.map(att => {
                                const fileType = att['content-type'] || '';
                                const thumbUrl = att.thumb_path ? (thumbUrlMapRef.current[att.thumb_path] || null) : null;
                                const fullUrl = fileUrlMapRef.current[att.path] || null;
                                return {
                                    ...att,
                                    thumb_url: thumbUrl,
                                    file_url: fullUrl,
                                    file_type: fileType,
                                };
                            });
                            return {
                                ...message,
                                attachments: updatedAttachments,
                            };
                        }
                        return message;
                    });

                    setMessages(
                        updatedMessages
                            ?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                            ?.reverse()
                    );
                    setMessagesLoading(false);
                });
        } catch (error) {
            setMessagesLoading(false)
        }
    }

    const openImageModal = (url) => {
        if (!url) return;
        setClickedImage(url);
        setImageList([]);
        setImageStartIndex(0);
        setShowModal(true);
    };

    const resolveUrlByPath = async (path) => {
        if (!path) return null;
        if (fileUrlMapRef.current[path]) return fileUrlMapRef.current[path];
        try {
            const url = await fetchFileUrlByPath(path);
            if (url) {
                fileUrlMapRef.current[path] = url;
                return url;
            }
        } catch (error) {
            console.error('Error resolving URL for path:', path, error);
        }
        return null;
    };


    const openMessageGallery = async (message, clickedAtt) => {
        if (!message?.attachments?.length) return;
        const imageAtts = message.attachments.filter((a) => a.file_type?.startsWith('image/'));
        if (!imageAtts.length) return;
        const clickedIndexAll = imageAtts.findIndex((a) => a.path === clickedAtt.path);
        const urls = await Promise.all(
            imageAtts.map(async (a) => {
                if (a.file_url) return a.file_url;
                return await resolveUrlByPath(a.path);
            })
        );
        const valid = urls
            .map((u, i) => ({ url: u, idx: i }))
            .filter((x) => !!x.url);
        const startIdx = Math.max(0, valid.findIndex((v) => v.idx === clickedIndexAll));
        setImageList(valid.map((v) => v.url));
        setImageStartIndex(startIdx === -1 ? 0 : startIdx);
        setShowModal(true);
    };
    const onClose = () => setShowModal(false);

    const getInitial = (name) => (name ? name.charAt(0).toUpperCase() : '?');

    return (
        <Box className="messages_box" style={{justifyContent:`${messages?.length > 0 ? 'flex-start' : 'space-between'}`}}>
            <Box display={'flex'} alignItems={'center'} style={{justifyContent:'flex-start'}}>
                <Typography
                    className='od-sectionTitle'
                    variant="body1"
                >
                    {translate('messages')}
                </Typography>
            </Box>
            {
                <>
                    {
                        messagesLoading ? (
                            <><Box justifyContent={'flex-start'}><div
                                style={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: 'calc(var(--fs-xl)*2.5)',
                                    alignSelf:'flex-start',
                                    margin: 0
                                }}
                            >
                                <div className="msg-loader-container">
                                    <div className="msg-loader bouncing-dots"></div>
                                </div>
                            </div></Box><Box>
                                </Box></>
                        ) : messages?.length > 0 && chatBoxHeight? (
                            <>
                                <Box className="chat_box" ref={chatBoxRef} style={{ maxHeight: chatBoxHeight ? `${chatBoxHeight}px` : 'calc(var(--fs-xl)*15)',minHeight:'0'}}>
                                    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: "var(--sp-md2)" }}>
                                        {
                                            messages.map((message, i) => {
                                                const isMe = String(user?.id) === String(message?.message_sent_by_user_id);
                                                return (
                                                <Box key={i} sx={{ display: 'flex', justifyContent: isMe ? 'flex-end' : 'flex-start', alignItems: 'flex-end', gap: 'var(--sp-xs)' }}>
                                                    {!isMe && (
                                                        <Box className="msg-avatar">
                                                            {getInitial(message?.message_sent_by_user_first_name)}
                                                        </Box>
                                                    )}
                                                    <Box className={isMe ? 'msg-bubble msg-bubble--me' : 'msg-bubble msg-bubble--other'}>
                                                        {!isMe && (
                                                            <Typography
                                                                variant="body1"
                                                                className='msg-sender'
                                                            >
                                                                {message?.message_sent_by_user_first_name || 'Dealer'}
                                                            </Typography>
                                                        )}
                                                        <Box><Typography
                                                            variant="body1"
                                                            className='value'
                                                            sx={{
                                                                wordBreak: 'break-word',
                                                                flex: 1, lineHeight: '100%'
                                                            }}
                                                        >
                                                            {formatMessageBody(message.body)}
                                                        </Typography>
                                                            {message?.created_at && (
                                                                <Typography
                                                                    variant="caption"
                                                                    className='sub-value'
                                                                    color="text.secondary"
                                                                    sx={{ mt: 'calc(var(--sp-xxs)*2)', display: 'block' }}
                                                                >
                                                                    {formatDate(message.created_at)}
                                                                </Typography>
                                                            )}
                                                            {message.attachments && message.attachments.length > 0 && (
                                                                <Box sx={{ mt: 'calc(var(--sp-md2)*0.914)', display: 'flex', gap: "calc(var(--sp-xxs)*2)" }}>
                                                                    {message.attachments.map((att, idx) => {
                                                                        const isImage = att.file_type?.startsWith('image/');
                                                                        if (isImage) {
                                                                            return (
                                                                                <Box key={idx} sx={{ position: 'relative', width: 'calc(var(--fs-xl)*1.5)', height: 'calc(var(--fs-xl)*1.5)' }}>
                                                                                    {att.thumb_url && loadingImages[att.thumb_url] !== false && (
                                                                                        <Box
                                                                                            sx={{
                                                                                                position: 'absolute',
                                                                                                top: 0,
                                                                                                left: 0,
                                                                                                width: '100%',
                                                                                                height: '100%',
                                                                                                display: 'flex',
                                                                                                alignItems: 'center',
                                                                                                justifyContent: 'center',
                                                                                                background: 'rgba(255,255,255,0.7)',
                                                                                                zIndex: 1,
                                                                                            }}
                                                                                        >
                                                                                            <CustomSpinner size={resolveCssVarValue('--fs-xl')} />
                                                                                        </Box>
                                                                                    )}
                                                                                    {att.thumb_url ? (
                                                                                        <Box
                                                                                            component="img"
                                                                                            src={att.thumb_url}
                                                                                            alt="attachment thumbnail"
                                                                                            sx={{
                                                                                                width: 'calc(var(--fs-xl)*1.5)',
                                                                                                height: 'calc(var(--fs-xl)*1.5)',
                                                                                                objectFit: 'cover',
                                                                                                cursor: 'pointer',
                                                                                                borderRadius: 1,
                                                                                                display: 'block',
                                                                                                zIndex:9999
                                                                                            }}
                                                                                            onClick={async (e) => {
                                                                                                e.stopPropagation();
                                                                                                await openMessageGallery(message, att);
                                                                                            }}
                                                                                            onLoad={() => handleImageLoad(att.thumb_url)}
                                                                                            onError={() => handleImageLoad(att.thumb_url)}
                                                                                            onLoadStart={() => handleImageStart(att.thumb_url)}
                                                                                        />
                                                                                    ) : (
                                                                                        <Box
                                                                                            component="img"
                                                                                            src={ThumbDefault}
                                                                                            alt="default thumbnail"
                                                                                            sx={{
                                                                                                width: 'calc(var(--fs-xl)*1.5)',
                                                                                                height: 'calc(var(--fs-xl)*1.5)',
                                                                                                borderRadius: 1,
                                                                                                backgroundColor: '#f0f0f0',
                                                                                                objectFit: 'contain',
                                                                                                cursor: 'pointer',
                                                                                                zIndex:9999

                                                                                            }}
                                                                                            onClick={async (e) => {
                                                                                                e.stopPropagation();
                                                                                                await openMessageGallery(message, att);
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                </Box>
                                                                            );
                                                                        }
                                                                        return (
                                                                            <Box
                                                                                key={idx}
                                                                                component="a"
                                                                                href={att.file_url || '#'}
                                                                                target={att.file_url ? "_blank" : undefined}
                                                                                rel={att.file_url ? "noopener noreferrer" : undefined}
                                                                                onClick={async (e) => {
                                                                                    if (!att.file_url) {
                                                                                        e.preventDefault();
                                                                                        e.stopPropagation();
                                                                                        const url = await resolveUrlByPath(att.path);
                                                                                        if (url) {
                                                                                            window.open(url, '_blank', 'noopener,noreferrer');
                                                                                        }
                                                                                    }
                                                                                }}
                                                                                sx={{
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    width: 'calc(var(--fs-xl)*1.5)',
                                                                                    height: 'calc(var(--fs-xl)*1.5)',
                                                                                    backgroundColor: '#f5f5f5',
                                                                                    borderRadius: 1,
                                                                                    cursor: 'pointer',
                                                                                    textDecoration: 'none',
                                                                                    zIndex:9999
                                                                                }}
                                                                            >
                                                                                <PictureAsPdfIcon sx={{ fontSize: 'calc(var(--fs-xl)*1.2)', color: '#d32f2f' }} />
                                                                            </Box>
                                                                        );
                                                                    })}
                                                                </Box>
                                                            )}
                                                        </Box>
                                                    </Box>
                                                </Box>
                                                );
                                            })
                                        }</Box>
                                    <Box textAlign={'end'} style={{ position: 'sticky', bottom: '0px', right: 'var(--sp-md2)' }}>
                                        {showTextButtons && <ReplyButton
                                            onClick={() => props.setOpenReply(true)}>{translate('reply')}</ReplyButton>}
                                    </Box>
                                </Box>
                            </>
                        ) : (
                            <><Typography
                                variant="body2"
                                mt={'calc(var(--sp-md2)*1.7)'}
                                style={{ textAlign: 'center',justifyContent:'center' }}

                            >
                                <OdFontScale fontSize="var(--fs-sm2)" color="rgba(106, 106, 137, 1)">{translate('noMessage')}</OdFontScale>

                            </Typography>
                            <Box></Box>
                            </>
                        )
                    }
                </>
            }
            <MessageImageZoom open={showModal} onClose={onClose} image={clickedImage} images={imageList} startIndex={imageStartIndex} />
        </Box>
    )
}
const mapStateToProps = (state) => {
    return {
        userInfo: getValueFromObjectByKeys(state, ['User', 'userInfo']),
        vendor: getValueFromObjectByKeys(state, ['User', 'vendor']),
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        clearOrderInViewDetails: () => dispatch(setOrderDetailsSliceData(null))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MessagesList)
